var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgCloudDownload = function SvgCloudDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.822c3.034 0 5.561 2.137 6.129 4.97 2.16.153 3.87 1.915 3.87 4.089 0 2.274-1.865 4.117-4.166 4.117H7c-2.762 0-5-2.212-5-4.94 0-2.55 1.952-4.645 4.459-4.912a6.256 6.256 0 0 1 5.54-3.324zM13 14v-2h2l-3-3-3 3h2v2a1 1 0 1 0 2 0z"
  })));
};

export default SvgCloudDownload;